// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"b55ea5b8","272":"53cae3af","366":"7ff10605","456":"1fc6a442","532":"243ac060","567":"fe8b6069","585":"0d80dd0a","652":"48b1789c","669":"46b8a6f6","964":"7325ac0d","986":"809195b4"}[chunkId] + ".css";
};